module.exports = __webpack_public_path__ + "img/church.b29070d0.png";